<template>
  <div id="tab_performance" class="tab-pane fade in active">
    <div class="tab__header">Performance Evaluation</div>
    <Benchmarks :practice-benchmark="practiceBenchmark"></Benchmarks>
    <Comparisons></Comparisons>
    <div class="kpi__table-container kpi__table-container--bordered">
      <div class="grid h-unset-max-width">
        <div class="grid__col--6">
          <div class="tab__sub-header">KPI TRACKING</div>
        </div>
        <div class="grid__col--6"></div>
      </div>
      <table class="kpi-performance-table">
        <TableHead title="KPI" :month-year-string="monthYearString"></TableHead>
        <TableSubHead></TableSubHead>
        <component v-bind:is="getComponentName(metric.field)" v-for="(metric, index) in metricsKpiTracking" :key="`kpi-tracking-${metric.field}-${index}`" :metric="metric"></component>
      </table>
      <div class="legend">BMK = Benchmark of similar sized practices.</div>

      <div class="grid h-unset-max-width">
        <div class="grid__col--6">
          <div class="tab__sub-header">PRACTICE LOCATIONS & PROVIDER INFORMATION</div>
        </div>
        <div class="grid__col--6"></div>
      </div>
      <table class="kpi-performance-table">
        <TableHead title="KPI" :month-year-string="monthYearString"></TableHead>
        <TableSubHead></TableSubHead>
        <component v-bind:is="getComponentName(metric.field)" v-for="(metric, index) in metricsLocationsAndProviders" :key="`locations-providers-${index}`" :metric="metric"></component>
      </table>
      <div class="legend">BMK = Benchmark of similar sized practices.</div>

      <div class="grid h-unset-max-width">
        <div class="grid__col--6">
          <div class="tab__sub-header">TESTING STATISTICS</div>
        </div>
        <div class="grid__col--6"></div>
      </div>
      <table class="kpi-performance-table">
        <TableHead title="KPI" :month-year-string="monthYearString"></TableHead>
        <TableSubHead></TableSubHead>
        <component v-bind:is="getComponentName(metric.field)" v-for="(metric, index) in metricsTestingStatistics" :key="`testing-${index}`" :metric="metric"></component>
      </table>
      <div class="legend">BMK = Benchmark of similar sized practices.</div>

      <div class="grid h-unset-max-width">
        <div class="grid__col--6">
          <div class="tab__sub-header">TREATMENT STATISTICS</div>
        </div>
        <div class="grid__col--6"></div>
      </div>
      <table class="kpi-performance-table">
        <TableHead title="KPI" :month-year-string="monthYearString"></TableHead>
        <TableSubHead></TableSubHead>
        <component v-bind:is="getComponentName(metric.field)" v-for="(metric, index) in metricsTreatmentStatistics" :key="`treatment-${index}`" :metric="metric"></component>
      </table>
      <div class="legend">BMK = Benchmark of similar sized practices.</div>
    </div>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import TableHead from './performance-evaluation/TableHead.vue';
  import TableSubHead from './performance-evaluation/TableSubHead.vue';
  import TableRowBase from './performance-evaluation/table-rows/TableRowBase.vue';
  import TableRowTestsSubtotal from './performance-evaluation/table-rows/TableRowTestsSubtotal.vue';
  import TableRowVialsTotalNewPatients from './performance-evaluation/table-rows/TableRowVialsTotalNewPatients.vue';
  import TableRowVialsTotal from './performance-evaluation/table-rows/TableRowVialsTotal.vue';
  import TableRowNewPatientsTotal from './performance-evaluation/table-rows/TableRowNewPatientsTotal.vue';
  import TableRowActivePatientsSubtotal from './performance-evaluation/table-rows/TableRowActivePatientsSubtotal.vue';
  import TableRowNumTestsPerPhysician from './performance-evaluation/table-rows/TableRowNumTestsPerPhysician.vue';
  import TableRowNumTestsPerTech from './performance-evaluation/table-rows/TableRowNumTestsPerTech.vue';
  import TableRowTestedToTreatmentConversionRate from './performance-evaluation/table-rows/TableRowTestedToTreatmentConversionRate.vue';
  import TableRowPercentNewPatientsOnScit from './performance-evaluation/table-rows/TableRowPercentNewPatientsOnScit.vue';
  import TableRowPercentNewPatientsOnSlit from './performance-evaluation/table-rows/TableRowPercentNewPatientsOnSlit.vue';
  import TableRowNumInjectionsPerTech from './performance-evaluation/table-rows/TableRowNumInjectionsPerTech.vue';
  import TableRowNumVialsMixedPerTech from './performance-evaluation/table-rows/TableRowNumVialsMixedPerTech.vue';
  import TableRowNumVialsMixedPerMixingLocation from './performance-evaluation/table-rows/TableRowNumVialsMixedPerMixingLocation.vue';
  import TableRowNumErrorsPerTech from './performance-evaluation/table-rows/TableRowNumErrorsPerTech.vue';
  import Comparisons from './Comparisons.vue';
  import Benchmarks from './Benchmarks.vue';

  export default {
    name: 'Performance',
    components: {
      Benchmarks,
      Comparisons,
      TableHead,
      TableSubHead,
      TableRowBase,
      TableRowTestsSubtotal,
      TableRowVialsTotalNewPatients,
      TableRowVialsTotal,
      TableRowNewPatientsTotal,
      TableRowActivePatientsSubtotal,
      TableRowNumTestsPerPhysician,
      TableRowNumTestsPerTech,
      TableRowTestedToTreatmentConversionRate,
      TableRowPercentNewPatientsOnScit,
      TableRowPercentNewPatientsOnSlit,
      TableRowNumInjectionsPerTech,
      TableRowNumVialsMixedPerTech,
      TableRowNumVialsMixedPerMixingLocation,
      TableRowNumErrorsPerTech,
    },
    data() {
      return {
        compMode: 'number',
        pugTemplateName: 'PerformanceEvaluationTableRow.pug',
      };
    },
    computed: {
      ...mapGetters('allergyKpis', [
        'practiceBenchmark',
        'trackingSections',
        'metricsKpiTracking',
        'metricsLocationsAndProviders',
        'metricsTestingStatistics',
        'metricsTreatmentStatistics',
        'ytdCustomCalculationFields',
        'monthsInReport',
        'month',
        'yearStart',
        'year',
      ]),
      currentMonthName() {
        const month = lodash.find(this.monthsInReport, (month) => month.value === this.month);
        return (month) ? month.label : '';
      },
      currentYearName() {
        return (this.month) + this.yearStart > 13 ? parseInt(this.year) + 1 : parseInt(this.year);
      },
      monthYearString() {
        return `- ${this.currentMonthName} ${this.currentYearName}`;
      },
    },
    methods: {
      getComponentName(field) {
        if (this.ytdCustomCalculationFields.includes(field)) {
          return `TableRow${lodash.chain(field).camelCase().upperFirst().value()}`;
        }
        return 'TableRowBase';
      },
    },
  };
</script>
